import { Injectable, inject, signal } from '@angular/core';
import { Observable, of, shareReplay } from 'rxjs';
import { ApiService } from '../../shared/services/api.service';
import { HttpParams } from '@angular/common/http';
import { RegressionRate } from './drop.down.service';

export interface CorrelationRate {
  rateId: string;
  rateName: string;
  category: string;
  correlationsDefault: boolean;
}

export interface M2Data {
  rateFullName: string;
  value: number;
  reportDate: Date;
}

export interface RateDefinition {
  rateId: string;
  rateIdStatistical: string;
  rateName: string;
  rateStartDate?: Date;
  rateEndDate?: Date;
  rateCode?: string;
  lagValue: number;
  lagPeriod: string;
  category?: string;
  pa1?: boolean;
  rateFullName?: string;
  frequency?: string;
  frequencyAbbrv?: string;
  units?: string;
  seriesSource?: string;
  seriesId: string;
  legendTitle?: string;
  citation?: string;
}

@Injectable({
  providedIn: 'root',
})
export class RateService {
  private apiService = inject(ApiService);

  private rateCache = new Map<string, Observable<any>>();
  private m2Cache: Observable<any> | null = null;
  private rateDefinitionCache = new Map<string, Observable<RateDefinition>>();
  public selectedRegressionRate = signal<RegressionRate | undefined>(undefined);

  setSelecteRegressionRate(rate: RegressionRate | undefined): void {
    this.selectedRegressionRate.set(rate);
  }

  getRateData(rateId: string, dateKey?: string): Observable<any> {
    const key = `${rateId}-${dateKey}`;
    if (!this.rateCache.has(key)) {
      let params = new HttpParams();
      if (dateKey !== undefined && dateKey !== null) {
        params = params.set('dateKey', dateKey);
      }
      this.rateCache.set(key, this.apiService.get(`/api/rate/${rateId}`,
        { params }).pipe(shareReplay(1)));
    }
    return this.rateCache.get(key) ?? of([]);
  }

  getM2Data(): Observable<M2Data[]> {
    if (!this.m2Cache) {
      this.m2Cache = this.apiService.get<M2Data[]>('/api/rate/m2').pipe(shareReplay(1));
    }
    return this.m2Cache;
  }

  getRateDefinition(rateName: string): Observable<RateDefinition> {
    if (!this.rateDefinitionCache.has(rateName)) {
      this.rateDefinitionCache.set(rateName, this.apiService.get<RateDefinition>(`/api/rate/definition/${rateName}`).pipe(shareReplay(1)));
    }
    return this.rateDefinitionCache.get(rateName) ?? of();
  }

}